const defaultTheme = require('tailwindcss/defaultTheme')

/** @type {import('tailwindcss').Config} */
module.exports = {
    content: ['./src/**/*.{js,jsx,ts,tsx,sass}',],
    theme: {
        extend: {
            fontFamily: {
                sans: ['Source Sans Pro', ...defaultTheme.fontFamily.sans],
            },
            colors: {
                transparent: 'rgba(255,255,255,0)',
                primary: {
                    DEFAULT: '#00ABE5',
                    50: '#9EE6FF',
                    100: '#89E1FF',
                    200: '#60D7FF',
                    300: '#38CCFF',
                    400: '#0FC2FF',
                    500: '#00ABE5',
                    600: '#0081AD',
                    700: '#005775',
                    800: '#002D3D',
                    900: '#000305',
                    'text-base-aa': '#007EA8',
                    'text-base-aaa': '#006080',
                    'text-lg-aa': '#009DD1',
                    'text-lg-aaa': '#007EA8',
                },
                secondary: {
                    DEFAULT: '#E351BE',
                    50: '#FCF3FA',
                    100: '#FBE8F8',
                    200: '#F9D1F2',
                    300: '#F4ADE6',
                    400: '#ED79D3',
                    500: '#E351BE',
                    600: '#D131A1',
                    700: '#AE207F',
                    800: '#961E6C',
                    900: '#7D1E5C',
                    'text-base-aa': '#D322A6',
                    'text-base-aaa': '#A21A80',
                    'text-lg-aa': '#E042B9',
                    'text-lg-aaa': '#D322A6',
                },
                chambray: {
                    DEFAULT: '#363795',
                    50: '#A4A5DE',
                    100: '#9596D9',
                    200: '#7878CE',
                    300: '#5A5BC3',
                    400: '#4142B3',
                    500: '#363795',
                    600: '#27286C',
                    700: '#181943',
                    800: '#090919',
                    900: '#000000',
                    950: '#000000',
                    'text-base-aa': '#4142B3',
                    'text-base-aaa': '#4142B3',
                    'text-lg-aa': '#4142B3',
                    'text-lg-aaa': '#4142B3',
                },
                cinnamon: {
                    DEFAULT: '#D46F40',
                    50: '#F6E0D6',
                    100: '#F2D3C5',
                    200: '#EABAA4',
                    300: '#E3A183',
                    400: '#DB8861',
                    500: '#D46F40',
                    600: '#B35528',
                    700: '#863F1E',
                    800: '#582914',
                    900: '#2A1409',
                    950: '#130904',
                    'text-base-aa': '#863F1E',
                    'text-base-aaa': '#863F1E',
                    'text-lg-aa': '#D46F40',
                    'text-lg-aaa': '#D46F40'
                },
            },
            scale: {
                '102': '1.02',
                '200': '2',
                '300': '3',
            },
            transitionDelay: {
                '0': '0ms',
            },
            zIndex: {
                '-1': '-1',
                '100': '100',
                '200': '200',
            },
            boxShadow: {
                // 'inner': 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
                'inner-md': 'inset 0 4px 6px -1px rgb(0 0 0 / 0.1), inset 0 2px 4px -1px rgb(0 0 0 / 0.06), inset 0 -3px 4px -1px rgb(0 0 0 / 0.1)',
                'inner-lg': 'inset 0 10px 15px -3px rgb(0 0 0 / 0.1), inset 0 4px 6px -2px rgb(0 0 0 / 0.05)',
            },
        },
    },
    variants: {
        extend: {
            opacity: ['disabled'],
            zIndex: ['hover', 'active'],
        },
    },
    plugins: [
        require('@tailwindcss/forms'),
        require('./src/tailwind/inner-border')
    ],
}
